export const CREATE_COMPANY_SELECT_TYPE = 'importist/company/CREATE_COMPANY_SELECT_TYPE';



// WEBPACK FOOTER //
// ./src/container/company/constants.js